<template lang="pug">
  v-row(class="fill-height pa-0 pl-4 direction-container min-height-700")
    div(
      v-for="(direction) in directions"
      class="direction"
      :key="direction.id"
      :ref="`dir${direction.id}`"
    )
      div(
        v-show="openedDirectionNumber !== direction.id"
        @click="openDirection(direction.id)"
        class="direction-content-open-btn"
      )
      div(
        class="direction-content__container"
        :ref="`dir${direction.id}-content`"
        :class=`openedDirectionNumber === direction.id
                ? getBackgroundImage(direction.id) + ' direction-content__container--tinted'
                : getBackgroundImage(direction.id)`
      )
        div(class="image" :ref="`dir${direction.id}-bg`")
        div(class="direction-content__icon" :ref="`dir${direction.id}-icon`")
        div(class="direction-content__data")
          p(class="direction-title" :ref="`title${direction.id}`") {{ direction.name }}
          v-row(class="px-3")
            p(class="direction-title2") {{ direction.name }}
            v-spacer
            v-btn(
              v-if="openedDirectionNumber === direction.id"
              @click="closeDirection(direction.id)"
              icon
              dark
            )
              v-icon mdi-close
          v-row(
            class="direction-activity fill-height pa-5"
            :ref="`activ${direction.id}`"
          )
            router-link(
              v-for="activity in direction.activities"
              :key="activity.id"
              :to=`{
                name: 'CourseList',
                query: { 'search[direction]': direction.id, 'search[activity]': activity.id }
              }`
              class="direction-activity__link"
            )
              span {{ activity.name }}

</template>

<script>
import anime from 'animejs';
import SystemService from '@/services/API/SystemService';

const NUMBER_OF_DIRECTIONS = 6;

export default {
  data: () => ({
    directions: [],

    // animation data
    openedDirectionNumber: 0,

    openActivityAnim: null, // Анимация появления видов деятельности
  }),
  mounted() {
    this.getDirections();
  },
  methods: {
    initAnimation() {
      anime({
        targets: '.direction',
        translateY: [100, 0],
        opacity: [0, 1],
        // easing: 'easeOutExpo',
        duration: 900,
        translateX(el, i) {
          return [`${(i * 104) / NUMBER_OF_DIRECTIONS}%`, `${(i * 104) / NUMBER_OF_DIRECTIONS}%`];
        },
        delay: anime.stagger(100),
      });
    },
    openDirection(refIndex) {
      // this.getActivities(refIndex);
      this.closeDirection(this.openedDirectionNumber);
      this.openedDirectionNumber = refIndex;

      // Раскрытие блока направленности
      anime({
        targets: this.$refs[`dir${refIndex}`],
        translateY: [0, 20],
        translateX: 0,
        delay: 20,
        // scaleX: { value: this.totalDirections },
        easing: 'easeOutExpo',
        duration: 900,
        begin: () => {
          this.$refs[`dir${refIndex}`][0].style.zIndex = 2;
        },
      });
      anime({
        targets: this.$refs[`dir${refIndex}-content`],
        easing: 'easeOutExpo',
        duration: 900,
        delay: 200,
        translateX: ['-86%', 0],
        complete: () => {
          this.getActivities(refIndex);
        },
      });

      // Анимация появления фона
      anime({
        targets: this.$refs[`dir${refIndex}-bg`],
        easing: 'easeOutExpo',
        duration: 800,
        delay: 200,
        opacity: [0.01, 1],
      });

      // Анимация исчезновения иконки
      anime({
        targets: this.$refs[`dir${refIndex}-icon`],
        easing: 'easeOutExpo',
        duration: 200,
        opacity: [1, 0],
      });

      // Анимация поворота названия направленности
      anime({
        targets: this.$refs[`title${refIndex}`],
        translateY: [200, 8],
        translateX: [0, '-312%'],
        rotate: ['-90deg', 0],
        opacity: [1, 0],
        delay: 300,
        easing: 'easeOutExpo',
      });

      // Появление блока видов дятельности
      this.openActivityAnim = anime({
        targets: this.$refs[`activ${refIndex}`],
        translateX: [-100, 0],
        opacity: [0, 1],
        delay: 20,
        // easing: 'easeOutExpo',
        autoplay: false,
      });
    },
    closeDirection(refIndex) {
      if (this.openActivityAnim) this.openActivityAnim.pause();
      anime({
        targets: this.$refs[`dir${refIndex}`],
        translateY: { value: 0, delay: 20 },
        // scaleX: 1,
        translateX: {
          value: `${((this.openedDirectionNumber - 2) * 104) / NUMBER_OF_DIRECTIONS}%`,
          delay: 20,
        },
        delay: 20,
        duration: 800,
        easing: 'easeOutExpo',
        begin: () => {
          if (!refIndex) return;
          this.$refs[`dir${refIndex}`][0].style.zIndex = 0;
        },
        complete: () => {
          if (!refIndex) return;
          this.$refs[`dir${refIndex}`][0].style.zIndex = 0;
        },
      });
      anime({
        targets: this.$refs[`dir${refIndex}-content`],
        easing: 'easeOutExpo',
        duration: 600,
        translateX: '-86%',
      });

      // Анимация исчезновения фона
      anime({
        targets: this.$refs[`dir${refIndex}-bg`],
        easing: 'easeOutExpo',
        duration: 1000,
        opacity: [1, 0.01],
      });
      // Анимация появления иконки
      anime({
        targets: this.$refs[`dir${refIndex}-icon`],
        easing: 'easeOutExpo',
        duration: 500,
        delay: 400,
        opacity: [0, 1],
      });

      anime({
        targets: this.$refs[`title${refIndex}`],
        opacity: 1,
        translateY: [8, 200],
        translateX: [1, 0],
        rotate: [0, '-90deg'],
        easing: 'easeOutExpo',
      });
      anime({
        targets: this.$refs[`activ${refIndex}`],
        translateX: [0, 100],
        opacity: [1, 0],
        duration: 200,
        easing: 'easeOutExpo',
      });
      this.openedDirectionNumber = 0;
    },
    getDirections() {
      this.$rHandler(
        SystemService.getDirections(),
        (r) => {
          this.directions = r.data.data;
          this.directions.forEach((el) => this.$set(el, 'activities', []));
          this.totalDirections = r.data.data.length;
          this.$nextTick(() => { this.initAnimation(); });
        },
      );
    },
    getActivities(directionId) {
      const params = {
        'search[direction_id]': directionId,
        'per-page': 200,
      };
      this.$nextTick(() => {
        const dir = this.directions.find((el) => el.id === this.openedDirectionNumber);
        if (!dir) return;

        if (dir.activities.length) {
          this.openActivityAnim.play();
          return;
        }

        this.$rHandler(
          SystemService.getActivities(params),
          (r) => {
            const currentDir = this.directions.find((el) => el.id === this.openedDirectionNumber);
            // this.$set(currentDir, 'activities', r.data.data);

            const response = r.data.data;
            response.sort((a, b) => {
              if (a.name < b.name) return -1;
              if (a.name > b.name) return 1;
              return 0;
            });
            this.$set(currentDir, 'activities', response);
            // response.forEach((a, i) => {
            //   const column = Math.floor(i / 12);
            //   if (!currentDir.activities[column]) currentDir.activities[column] = [];
            //   currentDir.activities[column].push(a);
            //   // console.log(currentDir.activities[column]);
            // });
            this.openActivityAnim.play();
          },
        );
      });
    },
    getBackgroundImage(directionId) {
      let cssClass;
      switch (directionId) {
        case 1: cssClass = 'direction-robo'; break;
        case 2: cssClass = 'direction-tech'; break;
        case 3: cssClass = 'direction-art'; break;
        case 4: cssClass = 'direction-natural-science'; break;
        case 5: cssClass = 'direction-social'; break;
        case 6: cssClass = 'direction-tourism'; break;
        case 7: cssClass = 'direction-sport'; break;
        default: cssClass = 'direction-art'; break;
      }
      if (directionId === this.openedDirectionNumber) return `${cssClass}`;
      return cssClass;
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~@/styles/views/directions.scss";

</style>
